import { NgModule } from "@angular/core";
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { NgxLoadingModule } from "ngx-loading";
import { SharedModule } from "../shared/shared.module";
import IntegracaoBancariaComponent from "./mensageria-integracaobancaria.component";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import MensageriaIntegracaoBancariaComponent from "./mensageria-integracaobancaria.component";


const routes = [
    {
        path: 'mensageria-integracaobancaria',
        component: MensageriaIntegracaoBancariaComponent
    }
];


@NgModule({
    declarations: [MensageriaIntegracaoBancariaComponent],
    imports: [
        RouterModule.forChild(routes),
        SharedModule,
        Ng4LoadingSpinnerModule,
        MatButtonModule,
        FuseSharedModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatTooltipModule,
        NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
    ],
    exports: [MensageriaIntegracaoBancariaComponent]
})
export class MensageriaIntegracaoBancariaModule { }
